import Search from './Search';

export { default as caseInsensitiveFilter } from './caseInsensitiveFilter';

export default Search;